import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Autocomplete, Box, Divider, FormControlLabel, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import CommentDrawer from '../Common/Drawer';
import { createLead, updateLead } from '../../store/LeadSlice';
import PhoneInput from 'react-phone-input-2';
import GooglePlacesAutocomplete from '../Common/GoogleAutoComplete';

export default function LeadForm({ page, setPage, getManualLeads, leadModal, setLeadModal, setSelectedLead, title, resetTrigger, selectedLead = null }) {
    const dispatch = useDispatch();
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();

    const validationSchema = Yup.object({
        source: Yup.string().required("Source is required")
            .max(50, "Name must be at most 50 characters"),
        name: Yup.string()
            .max(50, "Name must be at most 50 characters")
            .required("Name is required"),
        email: Yup.string()
            .email("Enter a valid email"),
        phone: Yup.string()
            .required('Contact number is required')
            .matches(/^\+?(\d.*){10,}$/, 'Phone number is not valid')
            // .matches(/^\+?[1-9]\d{7,14}$/, 'Enter a valid phone number')
            // .min(8, 'Phone number must be at least 8 digits (including country code)')
            // .max(15, 'Phone number cannot exceed 15 digits (including country code)')
            .trim(),
        // about: Yup.string()
        //     .max(200, "Value must be at most 200 characters")
    });

    const formik = useFormik({
        initialValues: {
            source: "",
            email: "",
            name: "",
            phone: "",
            about: "",
            zipcode:"",
            details: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setLeadModal(false);

            if (selectedLead) {
                values.uuid = selectedLead.uuid;
                dispatch(updateLead(values)).then((res) => {
                    getManualLeads()
                })
            } else {

                dispatch(createLead(values)).then(() => {
                    if (page) {
                        setPage(0)
                    } else {
                        getManualLeads()
                    }
                })
            }
        },
    });

    useEffect(() => {
        if (selectedLead?.source && leadModal) {
            formik.setValues({
                source: selectedLead.source,
                email: selectedLead.email,
                name: selectedLead.name,
                phone: selectedLead.phone,
                about: selectedLead.about,
                details: selectedLead.details
            });
        } else {
            formik.resetForm();
        }
    }, [selectedLead, leadModal, resetTrigger]);

    useEffect(() => {
        if (selectedLead) {
            const disabled = JSON.stringify({
                source: formik.values.source,
                email: formik.values.email,
                name: formik.values.name,
                phone: formik.values.phone,
                about: formik.values.about,
                details: formik.values.details,
            }) === JSON.stringify({
                source: selectedLead.source,
                email: selectedLead.email,
                name: selectedLead.name,
                phone: selectedLead.phone,
                about: selectedLead.about,
                details: selectedLead.details
            });
            setIsButtonDisabled(disabled)
        }

    }, [selectedLead, formik.values])
    return (
        <CommentDrawer open={leadModal} setOpen={setLeadModal}>
            <Box className=" position-relative h-100">
                <form onSubmit={formik.handleSubmit} >
                    <Typography variant="h6" gutterBottom className='p-3'>
                        {title}
                    </Typography>
                    <Divider />
                    <div className='role-form-scroller px-3'>
                        <TextField
                            fullWidth
                            required
                            id="source"
                            name="source"
                            label="Source"
                            margin="normal"
                            variant="outlined"
                            placeholder='Source'
                            value={formik.values.source}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.source && Boolean(formik.errors.source)}
                            helperText={formik.touched.source && formik.errors.source}
                        />
                        <TextField
                            fullWidth
                            required
                            id="name"
                            name="name"
                            label="Name"
                            margin="normal"
                            variant="outlined"
                            placeholder='Name'
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                        />
                        <TextField
                            fullWidth
                            id="email"
                            name="email"
                            label="Email"
                            margin="normal"
                            variant="outlined"
                            placeholder='Email'
                            value={formik.values.email}
                            // onChange={formik.handleChange}
                            onChange={(e) => {
                                const lowerCaseEmail = e.target.value.toLowerCase();
                                formik.setFieldValue("email", lowerCaseEmail);
                            }}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />

                       
                        {/* <TextField
                            fullWidth
                            id="phone"
                            name="phone"
                            label="Phone"
                            type='number'
                            margin="normal"
                            variant="outlined"
                            placeholder='Phone'
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                            helperText={formik.touched.phone && formik.errors.phone}
                        /> */}
                        <Box sx={{ mt: 1.5 }}>
                            <PhoneInput
                                country={'us'}
                                value={formik.values.phone}
                                // onChange={(value) => formik.setFieldValue('phone', value)}
                                onChange={(value, countryData, e, formattedValue) => {
                                    // value = national number (e.g., 4155552671)
                                    // countryData.dialCode = '1' for US
                                    formik.setFieldValue('phone', formattedValue);
                                }}
                                placeholder="Enter phone number"
                                inputProps={{
                                    name: 'phone',
                                    required: true,
                                    autoFocus: false,
                                    onBlur: formik.handleBlur, // Important to trigger validation on blur
                                }}
                                inputStyle={{
                                    width: '100%',
                                    marginTop: '16px',
                                    marginBottom: '8px',
                                    // padding: '10px',
                                    height: '55px',
                                    borderRadius: '4px',
                                    backgroundColor: '#FAFBF8',
                                    border: formik.touched.phone && formik.errors.phone
                                        ? '1px solid #dc3545'
                                        : '1px solid #ccc',
                                }}
                                containerStyle={{
                                    marginBottom: '4px',
                                }}
                            />
                        </Box>
                        {formik.touched.phone && formik.errors.phone && (
                            <div style={{ color: '#dc3545', marginBottom: '7px', fontSize: '12px' }}>
                                {formik.errors.phone}
                            </div>
                        )}

                        {/* <TextField
                            fullWidth
                            id="about"
                            name="about"
                            label="Location"
                            margin="normal"
                            variant="outlined"
                            placeholder='Location'
                            value={formik.values.about}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.about && Boolean(formik.errors.about)}
                            helperText={formik.touched.about && formik.errors.about}
                        /> */}
                        <GooglePlacesAutocomplete
                        className={"mt-4 mb-2"}
                            onPlaceSelect={(place) => console.log(place)}
                            value={formik.values.about}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="about"
                            formik={formik}
                            error={formik.touched.about && Boolean(formik.errors.about)}
                            helperText={formik.touched.about && formik.errors.about}
                        />
                        <TextField
                            fullWidth
                            id="details"
                            name="details"
                            multiline
                            rows={5}
                            label="Details"
                            margin="normal"
                            variant="outlined"
                            placeholder='Details'
                            value={formik.values.details}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.details && Boolean(formik.errors.details)}
                            helperText={formik.touched.details && formik.errors.details}
                        />
                    </div>

                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => setLeadModal(false)}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                            disabled={selectedLead ? (isButtonDisabled || !formik.isValid) : !(formik.dirty && formik.isValid)}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </Box>
        </CommentDrawer>
    );
}